import type { IConstraint, TConstraints } from '@feathr/rachis';

import { EIntegrationTypes } from '../integrations';
import type { CampaignClass } from '.';
import type { ITTDCampaignAttributes } from './ttd_base';
import { TTDCampaign } from './ttd_base';

export type TOmniIntegration = EIntegrationTypes.Tradedesk | EIntegrationTypes.Facebook;

export interface IMetaSettings {
  page_id?: string;
}

// Pixl Plus
export interface IOmniCampaignAttributes extends ITTDCampaignAttributes {
  readonly _cls: CampaignClass.Omni;
  integrations?: TOmniIntegration[];
  meta_settings?: IMetaSettings;
}

export class OmniCampaign extends TTDCampaign<IOmniCampaignAttributes> {
  public override get constraints(): TConstraints<IOmniCampaignAttributes> {
    return {
      ...super.constraints,
      integrations: {
        presence: {
          allowEmpty: false,
          message: '^Select at least one channel to proceed',
        },
      },
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      meta_settings: (...args: any[]): IConstraint | undefined => {
        const attributes = args[1] as IOmniCampaignAttributes;
        const integrations = attributes.integrations ?? [];
        if (
          integrations.includes(EIntegrationTypes.Facebook) &&
          !attributes.meta_settings?.page_id
        ) {
          return {
            presence: {
              allowEmpty: false,
              message: '^A Facebook page is required when the Meta channel is selected',
            },
          };
        }
        return undefined;
      },
    };
  }

  public override getDefaults(): Partial<IOmniCampaignAttributes> {
    return {
      ...super.getDefaults(),
    };
  }
}
